import type { ProductsContent } from '../types/ProductsContent';
import type {
    PlainTextElement,
    PlainMultilineTextElement,
    ImageElement,
} from '../types/SiteContentElement';

export function createProductsContentPlaceholder(): ProductsContent {
    const emptyPlain: PlainTextElement = { kind: 'plainText' as const, key: '', content: '' };
    const emptyMulti: PlainMultilineTextElement = {
        kind: 'plainMultilineText' as const,
        key: '',
        content: '',
    };
    const emptyImage: ImageElement = { kind: 'image' as const, key: '', imageUrl: '' };

    return {
        common: {
            paginationRange: emptyPlain,
            searchResultsPageTitle: emptyPlain,
            tabs: {
                tabsAriaLabel: emptyPlain,
                Products: { title: emptyPlain },
                Datasheets: { title: emptyPlain },
                Resources: { title: emptyPlain },
                SimulationTools: { title: emptyPlain },
            },
        },
        ksim: {
            appliedAcVoltage: emptyPlain,
            biasVoltageInVolts: emptyPlain,
            capChangeRateInPercent: emptyPlain,
            capacitanceChangeVsAcVoltage: emptyPlain,
            capacitanceChangeVsBiasVoltage: emptyPlain,
            capacitanceChangeVsTemperature: emptyPlain,
            capacitanceInFarad: emptyPlain,
            currentInAmps: emptyPlain,
            esrInOhms: emptyPlain,
            frequencyInHz: emptyPlain,
            impedanceInOhms: emptyPlain,
            inductanceInHenry: emptyPlain,
            invalidOrEmptyDataReceived: emptyPlain,
            noSimulationDataAvailable: emptyPlain,
            s11Magnitude: emptyPlain,
            s11PhaseInDeg: emptyPlain,
            s21Magnitude: emptyPlain,
            s21PhaseInDeg: emptyPlain,
            temperatureInCelsius: emptyPlain,
            typicalElectricalPerformance: emptyPlain,
            voltageInVolts: emptyPlain,
        },
        browseAllProducts: {
            pageTitle: emptyPlain,
            pageSubtitle: emptyMulti,
            browseAllButtonLabel: emptyPlain,
            pageTitleBackgroundImage: emptyImage,
        },
        filters: {
            buttonLabels: {
                applyFilters: emptyPlain,
                clear: emptyPlain,
                closeFilters: emptyPlain,
                downloadTable: emptyPlain,
                filterAndSort: emptyPlain,
                openFilters: emptyPlain,
                resetAll: emptyPlain,
            },
            checkboxLabels: {
                inStock: emptyPlain,
            },
            labels: {
                additionalFilters: emptyPlain,
                allProducts: emptyPlain,
                appliedFilter: emptyPlain,
                resultCount: emptyPlain,
                resultCountCompact: emptyPlain,
            },
        },
        comparison: {
            compareButtonLabel: emptyPlain,
            removeAllButtonLabel: emptyPlain,
            addAnotherProductButtonLabel: emptyPlain,
            result: {
                pageTitle: emptyPlain,
                copyComparisonLinkButtonLabel: emptyPlain,
            },
        },
        product: {
            buyNow: emptyPlain,
            cantFindDataFor: emptyPlain,
            containsSpecificationChangesTooltip: emptyPlain,
            datasheet: emptyPlain,
            info: emptyPlain,
            keyResources: emptyPlain,
            loading: emptyPlain,
            noInventoryAvailable: emptyPlain,
            notForNewDesign: emptyPlain,
            obsolete: emptyPlain,
            productDetailsButtonLabel: emptyPlain,
            productsCountInStock: emptyPlain,
            requestSample: emptyPlain,
            specifications: emptyPlain,
            specsheet: emptyPlain,
            spiceFile: emptyPlain,
            viewDistributorInRegion: emptyPlain,
            whereToBuy: emptyPlain,
        },
        productsTable: {
            columnLabels: {
                compare: emptyPlain,
                partNumber: emptyPlain,
            },
        },
    };
}
